import React from 'react';
import "./footer.css"
function Footer() {
  return (
    <footer>
      {/* <div className="foot-panel1">
        Back to Top
      </div> */}
      <div className="foot-panel2">
        <ul>
          <p>Get to Know Us</p>
          <a>Careers</a>
          <a>Blog</a>
          <a>About Shop Zone</a>
          <a>Investor Relations</a>
          
        </ul>

        <ul>
          <p>Make Money with Us</p>
          <a>Sell products on Shop Zone</a>
          
          
          <a>Become an Affiliate</a>
          <a>Advertise Your Products</a>
          
        </ul>

        <ul>
          <p>Payment Products</p>
          <a>Business Card</a>
          <a>Shop with Points</a>
          <a>Reload Your Balance</a>
          <a>Currency Converter</a>
        </ul>

        <ul>
          <p>Let Us Help You</p>
          <a>Your Account</a>
          <a>Your Orders</a>
          <a>Shipping Rates & Policies</a>
          <a>Returns & Replacements</a>
          <a>Manage Your Content and Devices</a>
          <a>Help</a>
        </ul>
      </div>
      
      <div className="foot-panel4">
        <div className="pages">
          <a>Conditions of Use</a>
          <a>Privacy Notice</a>
          <a>Your Ads Privacy Choices</a>
        </div>
        <div className="copyrights">
          © 1996-2023, ShopZone.com, Inc. or its affiliates
        </div>
      </div>
    </footer>
  );
}

export default Footer;